@if (learnizMode$ | async; as mode) {
  <header class="landing-header">
    <nav class="top-nav" [class.show-menu]="showMenu" [class.hide-menu]="!showMenu" id="top-nav">
      <!--    <div-->
      <!--      style="position: fixed; top: 0; right: 0px; z-index: 9999"-->
      <!--      class="rs_skip rsbtn rs_preserve"-->
      <!--      id="rs1-landing"-->
      <!--      *ngIf="showMenu"-->
      <!--    >-->
      <!--      <a-->
      <!--        rel="nofollow"-->
      <!--        class="rsbtn_play"-->
      <!--        title="Ecoutez le texte avec ReadSpeaker webReader"-->
      <!--        [href]="urlReadSpeakerMenu"-->
      <!--      >-->
      <!--        <span class="rsbtn_left rsimg rspart">-->
      <!--          <span class="rsbtn_text"><span>Ecouter</span></span>-->
      <!--        </span>-->
      <!--        <span class="rsbtn_right rsimg rsplay rspart"></span>-->
      <!--      </a>-->
      <!--    </div>-->
      @if (showMenu) {
        <shared-read-speaker
          style="position: fixed; top: 0; right: 0; z-index: 1000"
          idButtonDom="rs1-landing"
          targetIdToRead="top-nav"></shared-read-speaker>
      }
      <div class="main-nav landing">
        <button class="keep icon-learniz-menu" (click)="toggleMenu()"></button>
        <div class="sub-nav">
          <ul>
            @if (learnizPerimeter$ | async; as learnizPerimeter) {
              <li>
                <a [href]="learnizPerimeter.url">
                  <span class="icon-learniz-house"></span>
                  {{ 'learniz.menu.perimeter' | wording }}
                </a>
              </li>
            }
            @if (!hideLandingMainScreen) {
              <li class="nav-scrollable">
                <a routerLink="./" fragment="init">
                  <span class="icon-learniz-story"></span>
                  {{ 'learniz.menu.home' | wording }}
                </a>
              </li>
            }
            @if (!(hideLandingMenu || hideLandingContent)) {
              <li class="nav-scrollable">
                <a routerLink="./" fragment="contents">
                  <span class="icon-learniz-bulb-shine"></span>
                  {{ 'learniz.menu.content' | wording }}
                </a>
              </li>
            }
            @if (!hideLandingMenu) {
              <li class="nav-scrollable">
                <a routerLink="./" fragment="summary">
                  <span class="icon-learniz-study"></span>
                  {{ 'learniz.menu.summary' | wording }}
                </a>
              </li>
            }
            @if (!(hideLandingMenu || hideStats)) {
              <li class="nav-scrollable">
                <a routerLink="./" fragment="stats">
                  <span class="icon-learniz-peak"></span>
                  {{ 'learniz.menu.results' | wording }}
                </a>
              </li>
            }
            @if (!hideSupport && (mode === modes.NORMAL || mode === modes.PREVIEW)) {
              <li class="help-link">
                <button class="keep" (click)="openSupportModal()">
                  <span class="icon-learniz-help"></span>
                  {{ 'learniz.menu.help' | wording }}
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
      <!-- old place button -->
    </nav>
  </header>
}

<shared-read-speaker
  style="position: fixed; top: 70px; left: 0; z-index: 10"
  idButtonDom="rs2-landing"
  targetIdToRead="landing-content"></shared-read-speaker>

<div id="landing-content">
  <learniz-landing-intro id="container-intro" (goDown)="scrollToSplitScreen()"></learniz-landing-intro>

  @if (!hideLandingMenu) {
    <div class="details-split" id="details-split" [ngClass]="hideLandingContent && hideStats ? 'details-basic' : ''">
      <div class="home-slide-nav">
        <ul>
          @if (!hideLandingContent) {
            <li class="item-slide-nav" [ngClass]="splitClass === 'split-content' ? 'active' : ''">
              <button class="keep" (click)="split(detailsItems.CONTENT)">
                <div class="liner"></div>
                <span>{{ 'learniz.menu.content' | wording }}</span>
              </button>
            </li>
          }
          <li class="item-slide-nav" [ngClass]="splitClass === 'split-summary' ? 'active' : ''">
            <button class="keep" (click)="split(detailsItems.SUMMARY)">
              <div class="liner"></div>
              <span>{{ 'learniz.menu.summary' | wording }}</span>
            </button>
          </li>
          @if (!hideStats) {
            <li class="item-slide-nav" [ngClass]="splitClass === 'split-stats' ? 'active' : ''">
              <button class="keep" (click)="split(detailsItems.RESULTS)">
                <div class="liner"></div>
                <span>{{ 'learniz.menu.results' | wording }}</span>
              </button>
            </li>
          }
        </ul>
      </div>
      <div class="section-slides">
        <div
          class="container-left-pattern"
          [style.background-image]="menuImage.type === imagesTypes.IMAGE ? 'url(' + menuImage.src + ')' : 'none'"
          [style.background-size]="menuImage.type === imagesTypes.IMAGE ? menuImage?.cssProperties?.backgroundSize : ''"
          [style.background-repeat]="
            menuImage.type === imagesTypes.IMAGE ? menuImage?.cssProperties?.backgroundRepeat : ''
          "
          [style.background-position]="
            menuImage.type === imagesTypes.IMAGE ? menuImage?.cssProperties?.backgroundPosition : ''
          ">
          @if (menuImage.type === imagesTypes.LOTTIE) {
            <shared-lottie
              [jsonPath]="menuImage.src"
              autoplay="true"
              loop="true"
              class="lottie-page lottie-page-landing-left"
              [class.vertex]="isVertex(menuImage.src)"></shared-lottie>
          }
        </div>
        <!-- for IE -->
        <div class="container-right-pattern"></div>
        @if (!hideLandingContent) {
          <learniz-landing-content id="contents"></learniz-landing-content>
        }
        <learniz-landing-summary id="summary"></learniz-landing-summary>
        @if (!hideStats) {
          <learniz-landing-stats id="stats"></learniz-landing-stats>
        }
      </div>
      @if (progress$ | async; as progress) {
        @if (progress.chapters[progress.chapters.length - 1]; as lastChapter) {
          <div class="landing-start-btn-box">
            @if (
              progress.currentSlideSlug !== lastChapter.slides[lastChapter.slides.length - 1].slug ||
              progress.status !== learnizStatus.COMPLETE
            ) {
              <button
                mat-raised-button
                class="btn-outline-primary landing-start-btn"
                color="primary"
                [routerLink]="['../chapter', progress.currentChapterIndex, progress.currentSlideIndex]"
                (click)="isLoading = true"
                tabindex="1">
                @if (hasStarted(progress)) {
                  <span>
                    {{ 'learniz.landing-page.continue' | wording }}
                  </span>
                } @else {
                  {{ 'learniz.landing-page.start' | wording }}
                }
                @if (isLoading) {
                  <span>
                    <mat-spinner diameter="20"></mat-spinner>
                  </span>
                }
              </button>
            } @else {
              <button
                mat-raised-button
                class="btn-outline-primary landing-start-btn"
                color="primary"
                [routerLink]="['../chapter', 0, 0]"
                (click)="isLoading = true"
                tabindex="1">
                {{ 'learniz.landing-page.redo' | wording }}
                @if (isLoading) {
                  <span>
                    <mat-spinner diameter="20"></mat-spinner>
                  </span>
                }
              </button>
            }
          </div>
        }
      }
      @if (!hidePrivacy) {
        <footer class="landing-footer">
          @if (locale$ | async; as locale) {
            <jump-rgpd-privacy
              [open-label]="'rgpd.open-label' | wording"
              [cgu-url]="'assets/shared/rgpd/' + locale + '/TEMPLATE_CGU.md'"
              [cgu-label]="'rgpd.cgu-label' | wording"
              [politic-url]="'assets/shared/rgpd/' + locale + '/TEMPLATE_POLITIQUE_DE_CONFIDENTIALITE.md'"
              [politic-label]="'rgpd.politic-label' | wording"
              [terms-url]="'assets/shared/rgpd/' + locale + '/TEMPLATE_MENTIONS_LEGALES.md'"
              [terms-label]="'rgpd.terms-label' | wording"
              [json-url]="'assets/shared/rgpd/' + locale + '/privacy-data.json'"
              class="learniz-rgpd"></jump-rgpd-privacy>
          }
        </footer>
      }
    </div>
  }
</div>
